module.exports = __webpack_public_path__ + "static/media/adv5.1dc96fb8.jpg";